import Vue from 'vue'
import Vuex from 'vuex'

import base from './base'
import wizard from './wizardstore'
import reasons from './reasons'

Vue.use(Vuex)

export const store = new Vuex.Store({

    modules: {
        wizard,
        base,
        reasons
    },
})